<app-spinner [active]="loading"></app-spinner>
<div
  [ngStyle]="{ background: 'url(assets/images/MADB-BANNER-7.jpg)' }"
  class="content-header"
  id="grad"
>
  <span class="header-title">Diagnostics</span>

</div>

<div class="vertical-spacer"></div>
<div>
  <button 
    mat-button 
    class="warning-btn"
    (click)="showLogContents()"
  >
    Show Log Contents
  </button>
</div>

<div class="vertical-spacer"></div>
<div>
  <button 
    mat-button 
    class="warning-btn"
    (click)="throwTestException()"
  >
    Throw Test Exception
  </button>
</div>

<div class="vertical-spacer"></div>
<div>
  <textarea 
    rows="1"
    cols="132"
    cdkTextareaAutosize
    [value]="logContents"
  >
  </textarea>
</div>
